import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const state = {
    products: [],
    categories: [],
    user: {},
    isRep: false,
    currency: {},
    stand: {},
    stand_name: '',
    basketInfo: [],
    company_name: '',
}

const mutations = {
    setStandPreviewProductsData(state, data) {
        state.user = data.user
        state.isRep = data.isRep
        state.currency = data.currency
        state.stand = data.stand
        state.stand_name = data.stand_name
        state.company_name = data.company.name

    },
    setProducts(state, data) {
        state.products = Object.assign([], data)
    },
    changeProducts(state, data) {
        let prods  = [...state.products];
        prods[data.i] = data.product;
        state.products = prods

    },
    setOpenStandPreviewProduct(state, index = null) {
        const buffProducts = state.products
        buffProducts.map((product, i) => {
            if(i === index) {
                product.open = !product.open
            } else  {
                product.open = false;
            }
            return product
        });
        state.products = buffProducts
    },
    setBasketInfo(state, data) {
        const buffData = [...state.basketInfo]
        let basketData = {quantity: data.quantity, total: data.total, product_id: data.product_id}
        if (data.index >= 0) {
            buffData[data.index] = basketData;
        } else {
            buffData.push(basketData);
        }
        state.basketInfo = buffData
    }
}

const actions = {
    getStandPreviewProducts({commit}, data) {
        axios
            .get(`/api/stands/get-stand-preview-products/${data.standId}/${data.companyTypeId}`)
            .then(response => {
                commit("setStandPreviewProductsData", response.data)

                const products = response.data.products
                products.map((item) => {
                    item.open = false
                })

                commit("setProducts", products)
            })
            .catch(error => {
                console.log(error);
            })
    },
}

const getters = {
    products: state => state.products,
    isRep: state => state.isRep,
    user: state => state.user,
    stand: state => state.stand,
    stand_name: state => state.stand_name,
    company_name: state => state.company_name,
    currency: state => state.currency,
    categories: state => state.categories,
    basketInfo: state => state.basketInfo,
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
})
